"use client";

import React, { type HTMLAttributeAnchorTarget, PropsWithChildren } from "react";

import { SupButton, type ButtonProps } from "@repo/core-ui";
import Link, { type LinkProps } from "next/link";
import { twMerge } from "tailwind-merge";

interface AdapterButtonProps extends PropsWithChildren<LinkProps> {
  target?: HTMLAttributeAnchorTarget | undefined;
  buttonProps?: ButtonProps;
  disabled?: boolean;
  className?: string;
  linkClassName?: string;
}

export default function AdapterLinkButton(props: AdapterButtonProps) {
  const { buttonProps, disabled, className, linkClassName, ...linkProps } = props;

  if (disabled) {
    return (
      <SupButton {...buttonProps} disabled className={className}>
        {props.children}
      </SupButton>
    );
  }

  return (
    <Link {...linkProps} className={twMerge("tap-highlight-none inline-flex", buttonProps?.fluid && "w-full", linkClassName)}>
      <SupButton {...buttonProps} className={twMerge("w-full cursor-pointer touch-manipulation", className)}>
        {props.children}
      </SupButton>
    </Link>
  );
}
